module.exports = __webpack_public_path__ + "static/media/logo-white.b6d62acc.png";